
export default function VacationRentalSection() {
  return (
    <section className="py-20 bg-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            The Art of Activity e.V.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Die Kunst der Aktivität - Gemeinnütziger Paddel/Sportverein mit Ferienunterkunft
          </p>
        </div>

        {/* Erstes Ferienhaus - Mobilheim */}
        <div className="mb-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
            <div>
              <img 
                alt="Ferienhaus Mobilheim" 
                className="rounded-lg shadow-lg object-cover w-full h-96" 
                src="https://img.webme.com/pic/j/jo-allround/20220603_132911.jpg"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">Ferienhaus Mobilheim</h3>
              <div className="space-y-4 text-gray-700">
                <p className="text-lg">
                  Erleben Sie erholsame Tage in unserem komfortablen Mobilheim in Rheinsberg. 
                  Ideal für Familien, Paare und Aktivurlauber, die die Natur und Ruhe des Harzes suchen.
                </p>
                <div className="bg-green-100 p-6 rounded-lg">
                  <h4 className="text-lg font-semibold text-green-900 mb-2">Standort: 16831 Rheinsberg</h4>
                  <p className="text-green-800 mb-4">Der Verein befindet sich am neuen Standort in OPR Rheinsberg!</p>
                  <div className="space-y-2">
                    <p className="text-green-800"><strong>Anfrage und Buchung:</strong> Direkt bei uns oder über Booking.com</p>
                    <a 
                      href="https://www.booking.com/hotel/de/de-borns-mobielhome.en-gb.html" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="inline-block bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Auf Booking.com buchen
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobilheim Bildergalerie */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <img 
                alt="Mobilheim Innenansicht" 
                className="w-full h-48 object-cover rounded-lg mb-4" 
                src="https://img.webme.com/pic/j/jo-allround/20220603_133607.jpg"
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Komfortable Ausstattung</h4>
              <p className="text-gray-600">Unser Mobilheim bietet alle Annehmlichkeiten für einen entspannten Aufenthalt.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <img 
                alt="Außenbereich Mobilheim" 
                className="w-full h-48 object-cover rounded-lg mb-4" 
                src="https://img.webme.com/pic/j/jo-allround/20220629_174201.jpg"
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Schöner Außenbereich</h4>
              <p className="text-gray-600">Genießen Sie die Natur auf der Terrasse und im Garten.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <img 
                alt="Mobilheim Gesamtansicht" 
                className="w-full h-48 object-cover rounded-lg mb-4" 
                src="https://img.webme.com/pic/j/jo-allround/Bild Mobilheim für Text.jpg"
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Ruhige Lage</h4>
              <p className="text-gray-600">Perfekt gelegen für Erholung und verschiedene Aktivitäten in der Natur.</p>
            </div>
          </div>

          {/* Mobilheim Ausstattung */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h4 className="text-2xl font-bold text-gray-900 mb-6">
              Mobilheim - Ausstattung &amp; Features
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                  <i className="ri-home-line text-white text-sm"></i>
                </div>
                <span>Vollausgestattetes Mobilheim</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                  <i className="ri-landscape-line text-white text-sm"></i>
                </div>
                <span>Terrasse &amp; Garten</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                  <i className="ri-car-line text-white text-sm"></i>
                </div>
                <span>Parkplatz vorhanden</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                  <i className="ri-group-line text-white text-sm"></i>
                </div>
                <span>Für Familien geeignet</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                  <i className="ri-bike-line text-white text-sm"></i>
                </div>
                <span>Aktivurlaubsmöglichkeiten</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                  <i className="ri-fire-line text-white text-sm"></i>
                </div>
                <span>Grillmöglichkeit</span>
              </div>
            </div>
          </div>
        </div>

        {/* Zweite Ferienwohnung - De´ Borns */}
        <div className="mb-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
            <div className="lg:order-2">
              <img 
                alt="De´ Borns Ferienwohnung" 
                className="rounded-lg shadow-lg object-cover w-full h-96" 
                src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/469725592.jpg?k=f3e9d5f2a74343c04740cb13a66b8334eca55adc98c4ef287a58abc2ca24acac&o=&hp=1"
              />
            </div>
            <div className="lg:order-1">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">De´ Borns Ferienwohnung</h3>
              <div className="space-y-4 text-gray-700">
                <p className="text-lg">
                  Maisonette Dachgeschosswohnung mit 45 m² in der 1./2. Etage. 
                  Stylisches und rustikales Ambiente in perfekter Harmonie vereint.
                </p>
                <div className="bg-blue-100 p-6 rounded-lg">
                  <h4 className="text-lg font-semibold text-blue-900 mb-2">Standort: 1 Kiefernweg, 16831 Rheinsberg</h4>
                  <p className="text-blue-800 mb-4">Komplett neu ausgebaute Ferienwohnung mit Gartenblick!</p>
                  <div className="space-y-2">
                    <p className="text-blue-800"><strong>Ausstattung:</strong> 2 Schlafzimmer, Küche, Flachbild-TV, Garten</p>
                    <p className="text-blue-800"><strong>Besonderheiten:</strong> Kostenloser Privatparkplatz, Grill verfügbar</p>
                    <a 
                      href="https://www.booking.com/hotel/de/de-borns-ferienwohnung.de.html" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Auf Booking.com buchen
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ferienwohnung Bildergalerie */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <img 
                alt="Ferienwohnung Innenansicht" 
                className="w-full h-48 object-cover rounded-lg mb-4" 
                src="https://cf.bstatic.com/xdata/images/hotel/max500/469726948.jpg?k=95abd7491cda9c4187571cbd51868f154d7a147d3bd339e25d4d1078474016c7&o="
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Moderne Einrichtung</h4>
              <p className="text-gray-600">Die Ferienwohnung besticht durch moderne Ausstattung und gemütliches Ambiente.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <img 
                alt="Ferienwohnung Küche" 
                className="w-full h-48 object-cover rounded-lg mb-4" 
                src="https://cf.bstatic.com/xdata/images/hotel/max500/469727464.jpg?k=ac4b498776f61bd132e022eb152fe5c7dd76faa49bdfc52df68ca41f3efaf262&o="
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Vollausgestattete Küche</h4>
              <p className="text-gray-600">Moderne Küchenausstattung für Selbstversorger mit allem was Sie brauchen.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <img 
                alt="Ferienwohnung Schlafzimmer" 
                className="w-full h-48 object-cover rounded-lg mb-4" 
                src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/469726319.jpg?k=39ce978d601e8819dd40e5a973776868a725493787d20c4d26c2c2c2680a6322&o="
              />
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Gemütliche Schlafzimmer</h4>
              <p className="text-gray-600">Erholsamer Schlaf in komfortablen und stilvoll eingerichteten Zimmern.</p>
            </div>
          </div>

          {/* Ferienwohnung Ausstattung */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h4 className="text-2xl font-bold text-gray-900 mb-6">
              Ferienwohnung - Ausstattung &amp; Features
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-building-line text-white text-sm"></i>
                </div>
                <span>45 m² Maisonette-Wohnung</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-hotel-bed-line text-white text-sm"></i>
                </div>
                <span>2 Schlafzimmer</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-restaurant-line text-white text-sm"></i>
                </div>
                <span>Vollausgestattete Küche</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-tv-line text-white text-sm"></i>
                </div>
                <span>Flachbild-TV</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-car-line text-white text-sm"></i>
                </div>
                <span>Kostenloser Privatparkplatz</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-plant-line text-white text-sm"></i>
                </div>
                <span>Gartenzugang &amp; Grillmöglichkeit</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-stairs-line text-white text-sm"></i>
                </div>
                <span>1./2. Etage Maisonette</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-eye-line text-white text-sm"></i>
                </div>
                <span>Gartenblick</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                  <i className="ri-shield-check-line text-white text-sm"></i>
                </div>
                <span>Nichtraucherunterkunft</span>
              </div>
            </div>
          </div>
        </div>

        {/* Vereinsinfo */}
        <div className="bg-gray-900 text-white p-8 rounded-lg shadow-lg">
          <h4 className="text-2xl font-bold mb-6 text-center">
            The Art of Activity e.V.
          </h4>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="text-gray-300 mb-6">
                Unser gemeinnütziger Verein bietet nicht nur Unterkunft, sondern auch 
                verschiedene Aktivitäten rund um Wassersport und Naturerlebnisse.
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                    <i className="ri-sailboat-line text-white text-sm"></i>
                  </div>
                  <span>Paddel- &amp; Wassersport</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                    <i className="ri-mountain-line text-white text-sm"></i>
                  </div>
                  <span>Naturerlebnisse</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                    <i className="ri-team-line text-white text-sm"></i>
                  </div>
                  <span>Gemeinnütziger Verein</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-600 rounded-full mr-3">
                    <i className="ri-calendar-event-line text-white text-sm"></i>
                  </div>
                  <span>Verschiedene Aktivitäten</span>
                </div>
              </div>
            </div>
            
            <div className="text-center lg:text-left">
              <h5 className="text-xl font-semibold mb-4">Kontakt &amp; Buchung</h5>
              <div className="space-y-2 text-gray-300">
                <p><strong>Standort:</strong> 16831 Rheinsberg, OPR</p>
                <p><strong>Buchung:</strong> Direkt bei uns oder über Booking.com</p>
                <p><strong>Aktivitäten:</strong> Paddeln, Wassersport, Naturerlebnisse</p>
              </div>
            </div>
          </div>
        </div>

        {/* Wohnungsvermietung Banner */}
        <div className="mt-20 relative rounded-lg overflow-hidden shadow-2xl">
          <img 
            src="https://public.readdy.ai/ai/img_res/e0364a19c526154a02e25e9a7a312977.jpg"
            alt="Wohnungsvermietung"
            className="w-full h-80 object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-900/60 flex items-center justify-center">
            <div className="text-center px-6">
              <h3 className="text-4xl font-bold text-white mb-6">
                Wir vermieten auch Wohnungen
              </h3>
              <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
                Entdecken Sie unsere weiteren Vermietungsangebote
              </p>
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/wohnungsvermietung')}
                className="inline-block bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
              >
                Mehr erfahren
              </button>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
